import React from 'react';
import PropTypes from 'prop-types';

import { NameInput, LoyaltyIdInput } from './inputs';
import {
    PhoneNumberInput,
    PhoneNumberInputWithValidation,
} from '../common/inputs/phone-number';
import CreditBalance from './credit-balance';
import LoyaltyOptInCheckbox from "@/common/customer.loyalty/loyalty-opt-in-checkbox";
import DesktopView from "@/common/customer.loyalty/loyalty-opt-in-checkbox/DesktopView";

const {
    UI,
    _class: {
        Common: { Price },
    },
} = Mobi2Go;

const headoffice_loyalty_opt_in_feature_flag =
    Mobi2Go.app.feature_flags?.headoffice_loyalty_opt_in;

class SignedInForm extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        phone_number: PropTypes.string.isRequired,
        phone_number_country: PropTypes.string.isRequired,
        loyalty_id: PropTypes.string.isRequired,
        onLoyaltyIdChange: PropTypes.func.isRequired,
        credit_balance: PropTypes.instanceOf(Price),
        loyalty_opt_in_enabled: PropTypes.bool.isRequired,
        customer_loyalty_opt_in: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        credit_balance: null,
    };

    showCustomerDetails = () => {
        UI.trigger('showCustomerDetails');
    };

    render() {
        const {
            name,
            phone_number = '',
            phone_number_country,
            loyalty_id,
            onLoyaltyIdChange,
            credit_balance,
            customer_loyalty_opt_in,
            t,
            loyalty_opt_in_enabled,
        } = this.props;
        const { customer_phone_number_validation_enabled } = Mobi2Go.headoffice;

        return (
            <div>
                <NameInput value={name} onClick={this.showCustomerDetails} />
                {phone_number && customer_phone_number_validation_enabled ? (
                    <PhoneNumberInputWithValidation
                        value={phone_number}
                        country={phone_number_country}
                        disabled
                        onClick={this.showCustomerDetails}
                        containerClassName="m2g-customer-phone-input-container m2g-form-element--full-width"
                        className="m2g-customer-phone-input m2g-form-element--full-width"
                    />
                ) : (
                    <PhoneNumberInput
                        value={phone_number}
                        onClick={this.showCustomerDetails}
                        containerClassName="m2g-customer-phone-input-container m2g-form-element--full-width"
                        className="m2g-customer-phone-input m2g-form-element--full-width"
                    />
                )}

                {headoffice_loyalty_opt_in_feature_flag && (
                    <>
                        {loyalty_opt_in_enabled &&
                            <LoyaltyOptInCheckbox
                                ViewComponent={DesktopView}
                                optInString={t('customer:loyalty_opt_in_question')}
                                optInLink={t('customer:loyalty_scheme_name')}
                            />
                        }

                        {customer_loyalty_opt_in && (
                            <>
                                <LoyaltyIdInput
                                    value={loyalty_id}
                                    onChange={onLoyaltyIdChange}
                                />
                                <CreditBalance value={credit_balance} />
                            </>
                        )}
                    </>
                )}

                {!headoffice_loyalty_opt_in_feature_flag && (
                    <>
                        <LoyaltyIdInput
                            value={loyalty_id}
                            onChange={onLoyaltyIdChange}
                        />
                        <CreditBalance value={credit_balance} />
                    </>
                )}
            </div>
        );
    }
}

export default SignedInForm;
